module.exports = __webpack_public_path__ + "static/img/recommendIcon.4fbd479.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/recommendIcon.png
// module id = jobE
// module chunks = 1